import _ from 'lodash'

class ChangeBillingAddressModalCtrl {
    /** @ngInject */
    constructor(BillingAddress, User, ErrorCatcher) {
        this.BillingAddress = BillingAddress
        this.User = User
        this.ErrorCatcher = ErrorCatcher
    }

    $onInit() {
        this.loading = false
        this.isSubmitting = false
        this.isSubmitted = false
        this.form = {
            selectedAddress: null,
            details: {
                addr_details: undefined,
                addr_locality: undefined,
                addr_bat: undefined,
            },
        }
    }

    lookupAddress(addr) {
        const address$ = this.BillingAddress.showBillAddresses({ q: addr }).$promise
        address$.finally(() => {
            this.loading = false
        })
        return address$
    }

    submitAddress(data) {
        const newBillAdd = _.assign({}, this.form.selectedAddress, this.form.details)
        this.isSubmitting = true
        this.User.saveNewBillingAddress(newBillAdd).$promise.then((response) => {
            this.isSubmitted = true
        }).catch(this.ErrorCatcher.catchError)
        .finally(() => {
            this.isSubmitting = false
        })
    }

    closeModal() {
        this.close({ $value: { isSubmitted: this.isSubmitted } })
    }
}

export default {
    template: require('./change-billing-address-modal.jade')(),
    controller: ChangeBillingAddressModalCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<',
        close: '&', // {$value: myResult}
        dismiss: '&', // {$value: myRejectedResult}
    },
}



// WEBPACK FOOTER //
// ./src/states/personalInformation/modal/change-billing-address-modal.js